import * as Vue3EasyDataTable from "vue3-easy-data-table"
// eslint-disable-next-line no-unassigned-import
import "vue3-easy-data-table/dist/style.css"

export default defineNuxtPlugin((nuxtApp) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nuxtApp.vueApp.component("EasyDataTable", (Vue3EasyDataTable as any).default)
})
